import React, { useState } from 'react';
import {
  Grid, TextField, Select, MenuItem, Button, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination
} from '@mui/material';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { useDispatch, useSelector } from 'react-redux';

const Movimientos = () => {
  const [datosGenerados, setDatosGenerados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Estado de filtros
  const [filtroProducto, setFiltroProducto] = useState('');
  const [filtroTienda, setFiltroTienda] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const { token, user } = useSelector(state => state.auth); 
  const usuario = user.usuario; // Extrae el nombre de usuario
  // Estado de paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const setTiendas = ["TZ10", "TPRR", "TSCR", "TCSV", "TMIR", "TXLA"];

  // Filtra las tiendas según el nombre de usuario
  const tiendasFiltradas = setTiendas.filter(tienda => 
    usuario && tienda.includes(usuario)
  );

  const fetchDataMovimientos = async () => {
    setLoading(true);
    setError(null);

    try {
      const datos = {
        Token: "LJKNFUH2FWEJBAEFFFFFKJVGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
        Ambiente: "DESA",
        Dispositivo: {
          Marca: "SAMSUNG",
          Modelo: "S22002B",
          Version: "Android 18.125",
          McAdress: null,
          PowerStatus: "84%",
          WifiStatus: "Conected to iphone de Mauricio",
          GPSStatus: "ON",
          GPS: "321|-485|321"
        },
        Usr: {
          Codigo: "",
          UserNickName: usuario // Usa el nombre de usuario
        },
        DatosMetodo: {
          NombreMetodo: "ListaReportesSalas",
          Datos_Recibidos: `{"Vista":"Movimientos","FechaIni":"${fechaInicio}", "FechaFin": "${fechaFin}","Tienda":"${filtroTienda}","Producto":"${filtroProducto}"}`
        }
      };

      console.log(datos);
      const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;
      const response = await fetch(fetchDataUrl);

      if (!response.ok) {
        throw new Error('Error al obtener los datos');
      }

      const data = await response.json();
      if (data && data.datos_Generados) {
        const datosGeneradosLimpiados = typeof data.datos_Generados === 'string' 
          ? JSON.parse(data.datos_Generados) 
          : data.datos_Generados;

        setDatosGenerados(datosGeneradosLimpiados); 
        console.log(datosGeneradosLimpiados)
      } else {
        console.error("No se recibieron datos generados válidos:", data);
        setDatosGenerados([]);
      }

    } catch (error) {
      console.error("Error al obtener datos:", error);
      setError('Error al obtener los datos');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    fetchDataMovimientos(); 
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage); 
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10)); 
    setPage(0); 
  };

  const getRowStyle = (row) => {
    // Check if Movimiento is "Stock"
    if (row.Movimiento === "Stock") {
      return { backgroundColor: 'rgba(255, 255, 0, 0.2)' }; // Amarillo claro
    }
    
    // Check for negative values in any of the bodega fields
    const isNegative = 
      (parseFloat(row.BodegaOficial) < 0 || 
      (parseFloat(row.BodegaInsumos) < 0) || 
      (parseFloat(row.BodegaCocina) < 0));
    
    // Check for positive values in any of the bodega fields
    const isPositive = 
      parseFloat(row.BodegaOficial) > 0 || 
      (parseFloat(row.BodegaInsumos) > 0) || 
      (parseFloat(row.BodegaCocina) > 0);
    
    if (isNegative) {
      return { backgroundColor: 'rgba(255, 0, 0, 0.1)' }; // Rojo claro
    } else if (isPositive) {
      return { backgroundColor: 'rgba(0, 255, 0, 0.1)' }; // Verde claro
    }
    
    return {};
  };

  const exportToPDF = () => {
    const doc = new jsPDF({
      orientation: 'landscape'
    });
    
    // Add header with filter information
    doc.setFontSize(16);
    doc.setTextColor(40);
    doc.text('Reporte de Movimientos de Productos', 14, 15);
    
    doc.setFontSize(10);
    doc.text(`Filtros aplicados:`, 14, 25);
    doc.text(`Producto: ${filtroProducto || 'Todos'}`, 14, 30);
    doc.text(`Tienda: ${filtroTienda || 'Todas'}`, 14, 35);
    doc.text(`Fecha Inicio: ${fechaInicio || 'No especificada'}`, 14, 40);
    doc.text(`Fecha Fin: ${fechaFin || 'No especificada'}`, 14, 45);
    
    // Add current date
    const currentDate = new Date().toLocaleString();
    doc.text(`Generado el: ${currentDate}`, doc.internal.pageSize.width - 60, 15);
    
    // Add table
    doc.autoTable({
      startY: 50,
      head: [
        [
          'Sala', 
          'Fecha', 
          'Código', 
          'Descripción', 
          'Bodega Oficial',
          'Bodega Insumos',
          'Bodega Cocina', 
          'Movimiento', 
          'Comentario',
          'N° Movimiento',
          'Usuario'
        ]
      ],
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: 'bold'
      },
      body: datosGenerados.map(row => [
        row.Warehouse,
        row.DocDate,
        row.ItemCode,
        row.ItemName,
        row.BodegaOficial,
        row.BodegaInsumos,
        row.BodegaCocina,
        row.Movimiento,
        row.Comments,
        row.NumeroMov,
        row.Usuario
      ]),
      columnStyles: {
        0: { cellWidth: 'auto' },
        1: { cellWidth: 'auto' },
        2: { cellWidth: 'auto' },
        3: { cellWidth: 'auto' },
        4: { cellWidth: 'auto' },
        5: { cellWidth: 'auto' },
        6: { cellWidth: 'auto' },
        7: { cellWidth: 'auto' },
        8: { cellWidth: 'auto' },
        9: { cellWidth: 'auto' },
        10: { cellWidth: 'auto' }
      },
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: 'linebreak'
      },
      didParseCell: (data) => {
        // Color rows based on content
        if (data.row.index % 2 === 0) {
          data.cell.styles.fillColor = [245, 245, 245];
        }
        
        // Check for Stock movement
        if (data.column.index === 7 && data.cell.raw === "Stock") {
          data.cell.styles.fillColor = [255, 255, 0];
        }
        
        // Check for negative values in bodega columns (4,5,6)
        if ([4,5,6].includes(data.column.index) && parseFloat(data.cell.raw) < 0) {
          data.cell.styles.textColor = [255, 0, 0];
        }
        
        // Check for positive values in bodega columns (4,5,6)
        if ([4,5,6].includes(data.column.index) && parseFloat(data.cell.raw) > 0) {
          data.cell.styles.textColor = [0, 128, 0];
        }
      }
    });
    
    doc.save(`Movimientos_${fechaInicio}_${fechaFin}_${filtroTienda || 'Todas'}.pdf`);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(datosGenerados);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Movimientos');
    XLSX.writeFile(workbook, 'movimientos.xlsx');
  };

  return (
    <div>
      <h1>Movimientos Por Productos</h1>
      <hr />
      {/* Formulario de filtros */}
      <Grid container spacing={2} alignItems="center" marginBottom={2}>
        <Grid item xs={2}>
          <TextField
            id="filtroProducto"
            label="Producto (Código o Nombre)"
            value={filtroProducto}
            onChange={(e) => setFiltroProducto(e.target.value)}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <Select
            label="Tienda"
            value={filtroTienda}
            onChange={(e) => setFiltroTienda(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Todas las tiendas</MenuItem>
            {/* Si hay tiendas filtradas, muéstralas; si no, muestra todas */}
            {(tiendasFiltradas.length > 0 ? tiendasFiltradas : setTiendas).map((tienda, index) => (
              <MenuItem key={index} value={tienda}>{tienda}</MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="fechaInicio"
            label="Fecha de Inicio"
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="fechaFin"
            label="Fecha de Fin"
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <Button variant="contained" onClick={handleSearch}>
            Buscar
          </Button>
          <Button variant="contained" onClick={exportToPDF} style={{ marginLeft: "4px", marginRight: "4px" }} color='warning'>
            PDF
          </Button>
          <Button variant="contained" onClick={exportToExcel} color='success'>
            Excel
          </Button>
        </Grid>
      </Grid>

      {/* Tabla de resultados */}
      {loading ? (
        <p>Cargando...</p>
      ) : error ? (
        <p style={{ color: 'red' }}>{error}</p>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sala</TableCell>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Codigo</TableCell>
                  <TableCell>Descripcion</TableCell>
                  <TableCell>Bodega Oficial </TableCell>
                  <TableCell>Bodega Insumos </TableCell>
                  <TableCell>Bodega Cocina </TableCell>
                  <TableCell>Movimiento</TableCell>
                  <TableCell>Comentario</TableCell>
                  <TableCell>Numero de Movimiento</TableCell>
                  <TableCell>Usuario</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {datosGenerados.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                  <TableRow key={index} style={getRowStyle(row)}>
                    <TableCell>{row.Warehouse}</TableCell>
                    <TableCell>{row.DocDate}</TableCell>
                    <TableCell>{row.ItemCode}</TableCell>
                    <TableCell>{row.ItemName}</TableCell>
                    <TableCell style={{ 
                      color: parseFloat(row.BodegaOficial) < 0 ? 'red' : 
                            parseFloat(row.BodegaOficial) > 0 ? 'green' : 'inherit'
                    }}>
                      {row.BodegaOficial}
                    </TableCell>
                    <TableCell style={{ 
                      color: parseFloat(row.BodegaInsumos) < 0 ? 'red' : 
                            parseFloat(row.BodegaInsumos) > 0 ? 'green' : 'inherit'
                    }}>
                      {row.BodegaInsumos}
                    </TableCell>
                    <TableCell style={{ 
                      color: parseFloat(row.BodegaCocina) < 0 ? 'red' : 
                            parseFloat(row.BodegaCocina) > 0 ? 'green' : 'inherit'
                    }}>
                      {row.BodegaCocina}
                    </TableCell>
                    <TableCell>{row.Movimiento}</TableCell>
                    <TableCell>{row.Comments}</TableCell>
                    <TableCell>{row.NumeroMov}</TableCell> 
                    <TableCell>{row.Usuario}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={datosGenerados.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </div>
  );
};

export default Movimientos;